var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebhook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 37c-2.203 0-4-1.797-4-4 0-2.203 1.797-4 4-4 2.203 0 4 1.797 4 4 0 2.203-1.797 4-4 4z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 15l6.133 11A7.935 7.935 0 0 1 35 25c4.41 0 8 3.59 8 8s-3.59 8-8 8a7.982 7.982 0 0 1-6.238-3",
    fill: "none",
    strokeWidth: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#37474F",
    strokeOpacity: 1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 33H22c0 4.41-3.59 8-8 8s-8-3.59-8-8c0-3.719 2.555-6.855 6-7.746",
    fill: "none",
    strokeWidth: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#37474F",
    strokeOpacity: 1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 37c-2.203 0-4-1.797-4-4 0-2.203 1.797-4 4-4 2.203 0 4 1.797 4 4 0 2.203-1.797 4-4 4z",
    fill: "#E91E63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 19c-2.203 0-4-1.797-4-4 0-2.203 1.797-4 4-4 2.203 0 4 1.797 4 4 0 2.203-1.797 4-4 4z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 33l6.813-11.188A8.004 8.004 0 0 1 17 15c0-4.41 3.59-8 8-8s8 3.59 8 8c0 .7-.09 1.383-.262 2.031",
    fill: "none",
    strokeWidth: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#E91E63",
    strokeOpacity: 1,
    strokeMiterlimit: 10
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebhook);
export default __webpack_public_path__ + "static/media/webhook.aeae2a407d6262b3a326174b6041b781.svg";
export { ForwardRef as ReactComponent };